import { Button, dialog } from "nq-component";
import BasePage from "../../base/BasePage";
import CardView from "../common/CardView";
import { addSchemaUseCase } from "../../usecases/schema/usecases";
import React from "react";
import { findObjectUseCase } from "../../usecases/object";
import { formatDate, GetCurrentManilaTimeAPICall } from "../common/Converter";
import TimeManagementStatus from "./TimeManagementStatus";
import { getCurrentUserUseCase } from "../../usecases/user";

export default class ManageTimeInOut extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      progress: false,
      timeNow: "",
      dateToday: "",
      user: "",
    };
    this.timerID = null;
  }

  async componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
    const user = await getCurrentUserUseCase().execute();
    const employees = await findObjectUseCase().execute("employees", {
      where: { id: user.employee.id },
    });
    if (user.activeDirectory) {
      this.setState({ user: user.activeDirectory });
    } else {
      const fullName = [
        employees[0].Firstname,
        employees[0].Middlename,
        employees[0].surname,
      ]
        .filter(Boolean)
        .join(" ");
      this.setState({ user: fullName });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  async tick() {
    // const manilaTime = await getCurrentManilaTime();
    const manilaTime = await GetCurrentManilaTimeAPICall();
    const date = manilaTime;

    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    const formatterTime = manilaTime.toLocaleTimeString("en-PH", {
      timeZone: "Asia/Manila",
      hour12: false,
    });

    this.setState({
      timeNow: formatterTime,
      dateToday: formattedDate,
    });
  }

  async handleTimeIn() {
    try {
      const dayInLength = new Date();

      const object = {
        currentDate: formatDate(dayInLength),
        currentTime: this.state.timeNow,
        currentTimeOut: this.state.timeNow,
      };

      const timeManagementStats = new TimeManagementStatus();
      timeManagementStats.execute(
        this.getCurrentUser(),
        dayInLength,
        object,
        this.props.dailyTime,
        () => this.props.refetchData(),
      );
      dialog.close();
      // this.props.refetchData();
    } catch (error) {
      console.error("Error handling time in/out: ", error);
    }
  }

  // handleConfirmation() {
  //   dialog.fire({
  //     html: (
  //       <div>
  //         <div className="row p-2">
  //           <h4>
  //             {this.props.buttonLabel === "TIME-IN"
  //               ? "Time In Confirmation"
  //               : "Time Out Confirmation"}
  //           </h4>
  //           <hr />
  //           <p style={{ fontSize: "13px", padding: "1rem" }}>
  //             Click confirm to proceed.
  //           </p>
  //           <hr />
  //         </div>

  //         <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
  //           <Button
  //             className="btn btn-light fs-sm"
  //             onClick={() => dialog.close()}
  //           >
  //             Cancel
  //           </Button>
  //           <Button
  //             className="btn btn-primary"
  //             onClick={this.handleTimeIn.bind(this)}
  //           >
  //             Confirm
  //           </Button>
  //         </div>
  //       </div>
  //     ),
  //     footer: false,
  //   });
  // }

  render() {
    const { timeNow, dateToday, user } = this.state;
    return (
      <div className="row">
        <div className="col-lg-12 mb-3">
          <CardView>
            <div className="p-lg-3 mb-lg-4" style={{ height: "270px" }}>
              <h4>
                <strong>Welcome, {user}</strong>
              </h4>
              <div className="text-center p-3">
                <p style={{ fontSize: "20px" }}>The time now is</p>
                <h1 style={{ fontSize: "46px" }}>
                  <strong>{timeNow}</strong>
                </h1>
                <h3>{dateToday}</h3>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-end h-50">
              <div
                style={{
                  width: "90%",
                  marginBottom: "30px",
                }}
              ></div>
              {/* <Button
                style={{
                  width: "90%",
                  marginBottom: "10px",
                }}
                disabled={this.props.isDisable}
                progress={this.state.progress}
                onClick={this.handleConfirmation.bind(this)}
                className={`btn ${
                  this.props.buttonLabel === "TIME-OUT"
                    ? "bg-white text-danger border border-danger"
                    : this.props.buttonLabel === "You have already logged out"
                    ? "bg-white "
                    : "bg-primary text-white"
                }`}
              >
                {this.props.buttonLabel}
              </Button> */}
            </div>
          </CardView>
        </div>
      </div>
    );
  }
}
